import React, { useEffect, useState, useRef } from 'react';
import MediaPlayer from '../utils/MediaPlayer';
import anime from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import lang from '../lang.json';

const Module6a = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module6a;

    const [videoButton, setVideoButton] = useState(false);

    const [isVideoPlaying, setIsVideoPlaying] = useState(false);

    function trans() {
        playSubtitle();
        //play a mp3 file
        let audio = new Audio(process.env.PUBLIC_URL + `/assets/sounds/module6a.mp3`);
        audio.play();
        props.audio.push(audio)

        //Fade out content1 to content2
        let tl = anime.timeline({
            easing: 'easeOutExpo',
            duration: 5000,
        });
        tl.add({
            targets: '#content1',
            opacity: 0,
        }, 10000);
        tl.add({
            targets: '#content2',
            opacity: 1,
        }, 10000);
        //show texts
        tl.add({
            targets: '.text',
            opacity: 1,
            duration: 1000,
        }, 12000);
        setTimeout(() => {
            setVideoButton(true);
        }, 15000);
    }

    const playSubtitle = () => {
        //sous titres
        let tl2 = anime.timeline({})
        //dabord opacity 0 pour tous
        tl2.add({
            targets: '.st',
            opacity: 0,
            duration: 1,
        })
            .add({
                targets: '.st1',
                opacity: 1,
                duration: 1,
            }, 500)
            .add({
                targets: '.st1',
                opacity: 0,
                duration: 1,
            }, 4500)
            .add({
                targets: '.st2',
                opacity: 1,
                duration: 1,
            }, 4500)
            .add({
                targets: '.st2',
                opacity: 0,
                duration: 1,
            }, 9000)
    }

    useEffect(() => {
        trans()
    }, []);

    return (<>
        <div className="background" >
            <MediaPlayer
                source="module6a"
                initialDelay={0}
                paused={false}
                nbOfLoops={6}
                id="content1"
            />
            <img
                style={{
                    position: 'absolute',
                    top: '0px',
                    left: '0px',
                    zIndex: 1,
                    opacity: 0,
                }}
                src={process.env.PUBLIC_URL + `/assets/images/module6a/1.jpg`}
                id="content2"
            ></img>
        </div>
        <img style={{
            position: 'absolute',
            top: '466px',
            left: '380px',
            zIndex: 3,
            opacity: videoButton ? 1 : 0,
        }}
            className='inflateButtonMore'
            src={process.env.PUBLIC_URL + `/assets/images/module6a/2.jpg`} alt="video" id="video"
            onClick={() => {
                if (!isVideoPlaying) {
                    document.getElementById('videoPlayer').style.opacity = 1;
                    document.getElementById('videoPlayer').style.zIndex = 4;
                    document.getElementById('videoLubathy').play();
                    setIsVideoPlaying(true);
                }
                else {
                    document.getElementById('videoPlayer').style.opacity = 0;
                    document.getElementById('videoPlayer').style.zIndex = 0;
                    document.getElementById('videoLubathy').pause();
                    setIsVideoPlaying(false);
                }
            }}
        ></img>
        {/* video player */}
        <div style={{
            position: 'absolute',
            top: '0px',
            left: '0px',
            zIndex: 0,
            opacity: 0
        }}
            id='videoPlayer'
        >
            <video
                id="videoLubathy"
                width="660"
                height="450"
                controls
                src={process.env.PUBLIC_URL + `/assets/movies/06a_lubathy.mp4`}
            >
            </video>
        </div>

        {/* textes */}
        <p
            style={{
                position: 'absolute',
                left: 10,
                top: 0,
                color: 'white',
                fontSize: '15px',
                zIndex: 15
            }}
        >{texts.lang1}</p>

        {/* sous titres */}
        <p
            className="st1 st"
            style={{
                position: 'absolute',
                top: '412px',
                left: '10px',
                opacity: 1,
                color: 'white',
                backgroundColor: 'black',
                backgroundOpacity: 0.5,
                padding: '5px',
                opacity: 0,
            }}
        >
            {texts.lang30}
        </p>
        <p
            className="st2 st"
            style={{
                position: 'absolute',
                top: '412px',
                left: '10px',
                opacity: 1,
                color: 'white',
                backgroundColor: 'black',
                backgroundOpacity: 0.5,
                padding: '5px',
                zIndex: 18,
                opacity: 0,
            }}
        >
            {texts.lang31}
        </p>
        <p
            className="t1 text"
            style={{
                position: 'absolute',
                top: '130px',
                left: '20px',
                width: '500px',
                opacity: 0,
                zIndex: 2,
                color: 'white',
                fontSize: '15px',
                padding: '5px',
            }}
        >
            {texts.lang33}
        </p>
        <p
            className="t1 text"
            style={{
                position: 'absolute',
                top: '200px',
                left: '75px',
                width: '500px',
                opacity: 0,
                zIndex: 2,
                color: 'white',
                fontSize: '15px',
                padding: '5px',
            }}
        >
            {texts.lang34}
        </p>
        <p
            className="t1 text"
            style={{
                position: 'absolute',
                top: '230px',
                left: '75px',
                width: '500px',
                opacity: 0,
                zIndex: 2,
                color: 'white',
                fontSize: '15px',
                padding: '5px',
            }}
        >
            {texts.lang35}
        </p>
        <p
            className="t1 text"
            style={{
                position: 'absolute',
                top: '290px',
                left: '75px',
                width: '500px',
                opacity: 0,
                zIndex: 2,
                color: 'white',
                fontSize: '15px',
                padding: '5px',
            }}
        >
            {texts.lang36}
        </p>
    </>

    );
}

export default Module6a;